import styles from "./EmbedMap.module.css";

function EmbedMap() {
  return (
    <div className={styles.wrapper}>
      <iframe
        className={styles.map}
        title="Alo Asian Kitchen Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3511.139429934779!2d-90.13490848461536!3d29.9680159819076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8620a538c0e6326b%3A0x9374e1a036e8a380!2sAlo%20Asian%20Kitchen!5e0!3m2!1sen!2sus!4v1719353761487!5m2!1sen!2sus"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

export default EmbedMap;